var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("保单号")) + " ：" + _vm._s(_vm.policyInfo.policyNo))]), _c("div", [_vm._v(_vm._s(_vm.$t("产品名称")) + "：" + _vm._s(_vm.policyInfo.insuranceName))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单状态")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.policyStatus)))]), _c("div", [_vm._v(_vm._s(_vm.$t("生效日期")) + "：" + _vm._s(_vm.policyInfo.startAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("终止日期")) + "：" + _vm._s(_vm.policyInfo.endAt))])]), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔单信息")))])]), _c("a-form-model", {
    attrs: {
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 15
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("理赔类型"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.typeChange
    },
    model: {
      value: _vm.typeId,
      callback: function ($$v) {
        _vm.typeId = $$v;
      },
      expression: "typeId"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.description ? _c("div", {
    staticStyle: {
      "line-height": "initial",
      color: "#1890ff",
      "margin-top": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("类型说明")) + ":" + _vm._s(_vm.description) + " ")]) : _vm._e()], 1), _vm.list.length != 0 ? _c("a-alert", {
    attrs: {
      message: "*" + _vm.$t("请确认") + _vm.$t("根据指引提交相应理赔材料"),
      banner: ""
    }
  }) : _vm._e(), _vm.list.length != 0 ? _c("div", [_vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "nameBox"
    }, [_vm._v(_vm._s(_vm.$t(item.sortName)))]), _vm._l(item.claimsParam, function (item2, index2) {
      return _c("a-form-item", {
        key: index2,
        staticClass: "contItem",
        attrs: {
          label: _vm.$t(item2.paramName),
          "validate-status": item2.auditOpinion ? "error" : "validating",
          help: item2.auditOpinion ? item2.auditOpinion : ""
        }
      }, [item2.paramType == "text" ? _c("a-input", {
        attrs: {
          placeholder: _vm.$t("请填写") + " " + _vm.$t(item2.paramName)
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }) : _vm._e(), item2.paramType == "time" ? _c("a-date-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          allowClear: "",
          valueFormat: "YYYY-MM-DD",
          format: _vm.getFormatDate(),
          placeholder: _vm.$t("请选择") + item2.paramName
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }) : _vm._e(), item2.paramType == "dropDownBox" && item2.selectarr.length != 0 ? _c("a-select", {
        attrs: {
          placeholder: _vm.$t("请选择") + item2.paramName,
          showSearch: true
        },
        model: {
          value: item2.paramPlaceholder,
          callback: function ($$v) {
            _vm.$set(item2, "paramPlaceholder", $$v);
          },
          expression: "item2.paramPlaceholder"
        }
      }, _vm._l(item2.selectarr, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3.key
          }
        }, [_vm._v(" " + _vm._s(item3.vaule) + " ")]);
      }), 1) : _vm._e(), item2.paramType == "dropDownBox(region)" ? _c("area-select", {
        attrs: {
          index: index,
          index2: index2
        },
        on: {
          change: _vm.selectArea
        }
      }) : _vm._e()], 1);
    })], 2);
  }), _c("a-form-item", {
    attrs: {
      "wrapper-col": {
        span: 15,
        offset: 9
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 2) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };